// extracted by mini-css-extract-plugin
export default {"logoNav":"LogoNav_logoNav__aogWX"};